<template>
  <div id="patrol-route-panel-con">
    <div class="patrol-route-panel" :class="{ 'plan-list-shows': showPanel }">
      <div class="blur-bg map-blur-panel"></div>
      <div class="header">{{ panelTypeLabel[panelType] }}</div>
      <div class="ruleAdd-dialog flex-auto">
        <el-scrollbar class="scroll-content" style="height: 100%">
          <el-form
            label-width="101px"
            :rules="panelType == 2 ? {} : rules"
            :model="ruleForm"
            ref="form"
            :label-suffix="panelType == 2 ? '：' : ''"
            class="rule_conditions"
          >
            <!-- 计划名称等信息 -->
            <div class="ele-planInfo">
              <el-form-item label="计划名称" prop="planName">
                <span v-if="panelType == 2">
                  {{ ruleForm.planName }}
                </span>
                <el-input
                  v-model="ruleForm.planName"
                  clearable
                  v-else
                  placeholder="请输入计划名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="允许偏差" prop="deviation">
                <span v-if="panelType == 2">
                  {{ ruleForm.deviation }}
                </span>
                <el-input-number
                  v-else
                  v-model="ruleForm.deviation"
                  style="width: 57%"
                  :min="1"
                  :max="1000000"
                ></el-input-number>
                <span style="margin-left: 5px"> 米 </span>
              </el-form-item>
              <el-form-item label="计划日期" prop="dateType">
                <span v-if="panelType == 2"
                  >{{ ruleForm.planDate[0] + " 至 " + ruleForm.planDate[1] }}
                </span>
                <el-radio-group
                  style="margin-bottom: 10px"
                  v-model="ruleForm.dateType"
                  v-else
                  @change="handleDateChange"
                >
                  <el-radio label="1">一直执行</el-radio>
                  <el-radio label="2">指定日期</el-radio>
                </el-radio-group>
                <transition name="el-zoom-in-center">
                  <el-date-picker
                    v-model="ruleForm.planDate"
                    type="daterange"
                    v-if="panelType != 2"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    style="width: 100%; position: absolute; left: 0px; top: 40px"
                  ></el-date-picker>
                </transition>
              </el-form-item>
              <el-form-item
                label="巡更时间"
                :style="{ 'margin-top': panelType != 2 ? '50px' : '' }"
                prop="time"
              >
                <div v-if="panelType == 2" style="display: flex; flex-wrap: wrap">
                  <el-tag
                    v-for="(tag, index) in timeList"
                    :key="index"
                    :disable-transitions="false"
                  >
                    {{ tag.startTime + " - " + tag.endTime }}
                  </el-tag>
                </div>
                <div>
                  <span
                    type="text"
                    v-if="panelType != 2"
                    style="font-size: 15px; cursor: pointer"
                    class="el-icon-circle-plus-outline"
                    @click="handleShowTime"
                  >
                    添加</span
                  >
                  <div class="dateTime" v-if="showDate">
                    <div
                      :class="'0' == beginTime ? 'active' : ''"
                      class="time"
                      @click="handleSelectTime('0')"
                    >
                      0
                    </div>
                    <div
                      v-for="item in 24"
                      :key="item"
                      :class="item == beginTime ? 'active' : ''"
                      class="time"
                      @click="handleSelectTime(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </el-form-item>
              <div style="padding-left: 30px" v-if="panelType != 2">
                <el-tag
                  v-for="(tag, index) in timeList"
                  :key="index"
                  :closable="true"
                  @close="handleTagClose(index)"
                  :disable-transitions="false"
                >
                  {{ tag.startTime + " - " + tag.endTime }}
                </el-tag>
              </div>
              <el-form-item label="巡更执行人" prop="accountNumber">
                <span
                  type="text"
                  v-if="panelType != 2"
                  style="font-size: 15px; cursor: pointer"
                  class="el-icon-circle-plus-outline"
                  @click="handleAddPeople"
                >
                  添加</span
                >
              </el-form-item>
              <el-form-item label="" label-width="0">
                <div
                  style="max-height: 220px; overflow: auto"
                  class="group p15"
                  :class="executeTeams.length ? 'map-blur-panel__content ' : ''"
                >
                  <el-scrollbar ref="scrollBar" class="scroll-bar" style="height: 100%">
                    <ul class="worker-content">
                      <li
                        v-for="(item, ind) in executeTeams"
                        :key="ind"
                        class="flex-between"
                        style="padding-right: 10px; border-bottom: 1px solid #181f2e"
                      >
                        <div class="mb10">
                          <span class="f12 iconfont-lunan icon-lunan-renyuan"></span>
                          <span class="camera-name ml5">{{ item.name }}</span>
                          <span class="camera-name ml5" v-if="item.workNo"
                            >【安全员】</span
                          >
                          <span class="camera-name ml5" v-else>【安保】</span>
                        </div>
                        <div class="point-icon" v-if="panelType != 2">
                          <span
                            class="el-icon-delete ml5"
                            title="删除"
                            @click="deleteWorker(ind)"
                          ></span>
                        </div>
                      </li>
                    </ul>
                  </el-scrollbar>
                </div>
              </el-form-item>
            </div>
            <!-- 选择巡更位置 -->
            <div class="change-select">
              <div class="person-select">
                <span class="person-select-title">巡更点</span>
                <span style="font-size: 13px; margin-left: 16px" v-if="panelType != 2">
                  <el-button type="primary" style="cursor: auto"
                    >地图模式（默认）</el-button
                  >
                  <el-button type="primary" @click="handleShowPoint">列表模式</el-button>
                </span>
              </div>
              <el-table :data="patrolPointTable" @row-click="handleTableClick">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  label="名称"
                ></el-table-column>
                <el-table-column prop="area" label="位置" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{
                      scope.row.area == "室内"
                        ? "【" +
                          scope.row.area +
                          "】" +
                          scope.row.floorName +
                          scope.row.buildName
                        : scope.row.area
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type"
                  label="打卡方式"
                  align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row.type == 0 ? "GPS" : "二维码" }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="105"
                  align="center"
                  v-if="panelType != 2"
                >
                  <template slot-scope="scope">
                    <el-button
                      :disabled="scope.$index == 0"
                      type="text"
                      icon="el-icon-top"
                      title="上移"
                      style="font-size: 16px"
                      @click="handleUp(scope.$index)"
                    ></el-button>
                    <el-button
                      type="text"
                      title="下移"
                      style="font-size: 16px"
                      :disabled="scope.$index == patrolPointTable.length - 1"
                      icon="el-icon-bottom"
                      @click="handleDown(scope.$index)"
                    ></el-button>
                    <el-button
                      type="text"
                      title="移除"
                      style="font-size: 16px"
                      icon="el-icon-remove-outline"
                      @click="handleDel(scope.$index)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
        </el-scrollbar>
      </div>
      <!-- 底部按钮 -->
      <div class="footer">
        <el-button type="info" @click="handleClosePanel" :loading="btnLoading">{{
          btnLoading ? "提交中" : panelType == 2 ? "关闭" : "取消"
        }}</el-button>
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="handleSavePanel"
          v-if="panelType != 2"
          >{{ btnLoading ? "提交中" : "提交" }}</el-button
        >
      </div>
    </div>
    <el-dialog
      title="新增巡更点"
      :visible.sync="patrolDialog"
      :modal-append-to-body="false"
      width="400px"
      :before-close="handleCloseDialog"
    >
      <el-form
        :model="patrolForm"
        :rules="patrolRules"
        label-width="100px"
        ref="refPatrolForm"
      >
        <el-form-item prop="name" label="巡更点名称">
          <el-input v-model="patrolForm.name"></el-input>
        </el-form-item>
        <el-form-item label="打卡方式" prop="type">
          <el-radio-group v-model="patrolForm.type">
            <el-radio label="0">GPS</el-radio>
            <!-- <el-radio label="1" disabled>二维码</el-radio> -->
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="handleSaveDialog">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加执行组"
      :visible.sync="dialogVisible"
      width="600px"
      class="work-group"
      append-to-body
    >
      <work-group-tree
        ref="workGroupTree"
        :multiCheck="true"
        @groupData="getGroupData"
        :showPercentage="false"
      ></work-group-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelDia">取消</el-button>
        <el-button type="primary" @click="confirmDia">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择巡更点" :visible.sync="showPoint" width="940px" append-to-body>
      <div style="padding: 0 16px; display: flex" v-if="patrolPointTable.length">
        <div style="color: red">已选：</div>
        <div style="display: flex; flex-wrap: wrap">
          <div
            class="pointItem"
            style="margin: 0px 10px 2px 0; background: #d7e8ff; padding: 2px 5px"
            v-for="item in patrolPointTable"
            :key="item.pointCode"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <ioc-table
        ref="crud"
        :data="tableList"
        :option="option"
        :page="page"
        @search-change="getList"
        @search-reset="getList"
        @size-change="sizeChange"
        @current-change="pageChange"
        @selection-change="handleSelectionChange"
      >
      </ioc-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleCancelDia">取消</el-button>
        <el-button type="primary" @click="handleConfirmDia">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableOption from "../const/table";
import workGroupTree from "@src/modules/realTimeAlarm/components/workGroupTree";
import { api } from "../api";
import { Dates } from "$utils";
import utils from "@src/common/utils";
export default {
  name: "patrol-route-panel",
  components: {
    workGroupTree,
  },
  props: {
    panelType: {
      type: Number,
      default: 2,
    },
    showPanel: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    panelType: {
      handler(val) {
        // if (val == 2 || val == 0) {
        this.$nextTick(() => {
          this.$refs["form"].rules && this.$refs["form"].clearValidate();
        });
        // }
      },
      immediate: true,
    },
  },
  data() {
    return {
      key: 0,
      tableList: [],
      showPoint: false,
      btnLoading: false,
      executeTeams: [],
      checkPeople: [],
      dialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      panelTypeLabel: ["新建巡更计划", "修改巡更计划", "巡更计划详情"],
      patrolPointTable: [], //巡更点位table
      timeList: [
        // {
        //   startTime: "00:00",
        //   endTime: "24:00",
        // },
      ],
      patrolPlanCode: "",
      show: false,
      // showPanel: true,
      tableData: [],
      value: [1, 4],
      rules: {
        planName: [
          { required: true, message: "请输入计划名称" },
          {
            min: 1,
            max: 64,
            message: "长度在 1 到 64 个字符",
            trigger: "blur",
          },
        ],
        deviation: [{ required: true, message: "请输入偏差值" }],
        dateType: [{ required: true, message: "请选择计划日期" }],
        accountNumber: [{ required: true, message: "请选择负责人" }],
        time: [{ required: true, message: "请选择巡更时间", trigger: "change" }],
      },
      ruleForm: {
        dateType: "1", //计划日期
        planName: "",
        planDate: [],
        deviation: "50",
        time: [],
        accountNumber: [],
      },
      // new params
      patrolDialog: false,
      patrolForm: {
        name: "",
        type: "0",
      },
      patrolRules: {
        name: [{ required: true, message: "请输入巡更点名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择方式", trigger: "blur" }],
      },
      temporaryArray: [], //临时点位集合
      patrolArray: [], //巡更点位集合
      openPanel: false,
      showDate: false,
      beginTime: "",
      endTime: "",
      temporaryId: "temporaryPoint", //临时点位图层
      temporaryIdNum: "temporaryPointNum", //临时点位图层
      option: tableOption(this, true),
      searchForm: {},
      page: {
        pageNum: 1,
        total: 0,
        pageSize: 20,
      },
      checkPointList: [],
    };
  },
  created() {
    this.openPanel = true;
  },
  mounted() {
    this.handleDateChange(1);
    // 巡更点不再从地图上直接创建
    // this.$map.addClickEvent((data) => {
    //   console.log(this.panelType);
    //   if (this.panelType == 2 || this.panelType == 3) {
    //     return;
    //   }
    //   // 绘制巡更点位
    //   let markerArray = [
    //     {
    //       coord: [data[0], data[1]],
    //       anchor: [10, 25],
    //       scale: 1,
    //       src: "/images/theme/newDark/map/position_red.png",
    //       showTips: false,
    //     },
    //   ];
    //   this.temporaryArray.push(markerArray[0]);
    //   this.$map.MapInstance2D.addMarket(markerArray, "temporaryIcon");
    //   this.patrolDialog = true;
    // });
  },
  methods: {
    handleSelectionChange(items) {
      this.checkPointList = items.map((el) => {
        return el;
      });
    },
    getList(params) {
      this.page.pageNum = 1;
      this.searchForm = Object.assign({}, params);
      this.getListData();
    },
    getListData() {
      let params = {
        ...this.searchForm,
        ...this.page,
      };
      delete params.total;
      this.$fetch(api.queryResPointPage, params).then((res) => {
        if (res.success) {
          this.page.total = res.returnObj.total;
          this.tableList = res.returnObj.list;
          this.$nextTick(() => {
            this.patrolPointTable.forEach((item) => {
              this.tableList.forEach((el) => {
                if (item.pointCode == el.pointCode) {
                  console.log(el);
                  this.$refs.crud.$refs.multipleTable.toggleRowSelection(el, true);
                }
              });
            });
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.pageNum = 1;
      this.getListData();
    },
    pageChange(pageNo) {
      this.page.pageNum = pageNo;
      this.getListData();
    },

    handleCancelDia() {
      this.showPoint = false;
    },
    handleConfirmDia() {
      this.handleCancelDia();
      this.patrolPointTable = [];
      this.checkPointList.forEach((item) => {
        this.patrolPointTable.push({
          name: item.pointName,
          area: item.location,
          type: item.punchType,
          pointCode: item.pointCode,
          coord: [item.longitude, item.latitude],
        });
      });
      this.$nextTick(() => {
        this.handleChangePoint();
      });
    },

    handleShowPoint() {
      this.showPoint = true;
      this.page.pageSize = 20;
      this.getList();
    },
    deleteWorker(index) {
      this.executeTeams.splice(index, 1);
      if (this.executeTeams.length == 0) {
        this.$refs.form.validateField("accountNumber");
      } else {
        this.$refs.form.clearValidate("accountNumber");
      }
    },
    getGroupData(data) {
      this.checkPeople = [...data];
    },
    confirmDia() {
      this.executeTeams = [...this.checkPeople];
      if (this.executeTeams.length == 0) {
        this.$refs.form.validateField("accountNumber");
      } else {
        this.$refs.form.clearValidate("accountNumber");
      }

      this.dialogVisible = false;
    },
    cancelDia() {
      this.checkPeople = [];
      this.dialogVisible = false;
    },
    handleAddPeople() {
      this.dialogVisible = true;
      let checkedList = this.executeTeams.map((data) => {
        if (data.id) return data.id;
      });
      this.$nextTick(() => {
        this.$refs.workGroupTree.$refs.appAreaTree.setCheckedKeys(checkedList);
      });
    },
    handleTableClick(e) {
      console.log(e);
      if (e.area == "室外") {
        this.$map.MapInstance2D.setMapCenter([+e.coord[0], +e.coord[1]]);
      } else {
        this.$emit("handleFloorCenter", e);
        //根据楼栋id 定位到所属楼栋 e.buildingId
      }
    },
    handleSaveDialog() {
      this.handleSavePoint();
    },
    handleCloseDialog() {
      if (this.patrolDialog) {
        this.$refs.refPatrolForm.resetFields();
        this.handleCancelPoint();
      }
      this.patrolDialog = false;
    },
    handleCancelPoint() {
      console.log("取消建立巡更点位");
      this.$map.MapInstance2D.clearLayer("temporaryIcon");
      this.temporaryArray.splice(this.temporaryArray.length - 1, 1);
    },
    handleSavePoint() {
      this.$refs["refPatrolForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.patrolPointTable.push({
          name: this.patrolForm.name,
          area: "室外",
          type: this.patrolForm.type,
          coord: this.temporaryArray[0].coord,
        });
        this.handleChangePoint();
        this.$nextTick(() => {
          this.handleCloseDialog();
          this.checkPointList = [];
        });
      });
    },
    // 当点位发生顺序调换，删除,新增时统一处理
    handleChangePoint() {
      let addMarkInfo = [];
      let circleInfo = [];
      //混合点位，只打点新建立在地图上的点位
      this.patrolPointTable.forEach((item, index) => {
        // 新建立的点位
        if (!item.pointCode && item.area == "室外") {
          addMarkInfo.push({
            // id: "temporary-" + index, //唯一标识
            longitude: item.coord[0],
            latitude: item.coord[1],
            coord: item.coord,
            anchor: [10, 10],
            scale: 1,
            src: "/images/theme/newDark/map/patrol-points.png",
          });
        }
        // 室外地图渲染序号
        if (item.area == "室外") {
          circleInfo.push({
            longitude: item.coord[0],
            latitude: item.coord[1],
            radius: 9, //半径
            label: String(index + 1),
            outline: false, //是否显示轮廓线
            outlineWidth: 1,
            outlineColor: "#3E76E6", //轮廓线颜色
            fill: true, //是否填充颜色
            height: 10, //高度
            // anchor: [10, 25],
            fillColor: "#3E76E6", //颜色
            fillColorAlpha: 1, //透明度
            show: true, //是否可见，
            attr: {
              ...item,
            },
          });
        }
      });
      this.$map.MapInstance2D.addMarket(
        addMarkInfo,
        this.temporaryId,
        this.handleTemporaryClick
      );
      this.$map.MapInstance2D.addCircles(
        circleInfo,
        this.temporaryIdNum,
        this.handleTemporaryNumClick
      );
    },
    handleTemporaryNumClick(e) {
      console.log(e);
      let checkPoint = this.patrolPointTable;
      if (!e.marker.attr.pointCode) {
        this.$message.warning("该点位已在本次计划内，请勿重复选择");
      } else if (
        checkPoint.some((item) => {
          return item.pointCode == e.marker.attr.pointCode;
        })
      ) {
        this.$message.warning("该点位已在本次计划内，请勿重复选择");
      } else {
        console.log("圆圈数据");
      }
    },
    handleTemporaryClick(e) {
      this.$message.warning("该点位已在本次计划内，请勿重复选择");
    },
    handleUp(index) {
      let current = this.patrolPointTable.splice(index, 1);
      this.patrolPointTable.splice(index - 1, 0, current[0]);
      this.handleChangePoint();
    },
    handleDown(index) {
      let current = this.patrolPointTable.splice(index, 1);
      this.patrolPointTable.splice(index + 1, 0, current[0]);
      this.handleChangePoint();
    },
    handleDel(index) {
      this.patrolPointTable.splice(index, 1);
      this.handleChangePoint();
    },
    handleShowTime() {
      this.showDate = true;
    },
    handleDateChange(val) {
      if (val == 1) {
        this.ruleForm.planDate = [Dates.format(new Date(), "yyyy-MM-dd"), "9999-12-31"];
      } else {
        this.ruleForm.planDate = [];
      }
      console.log(this.ruleForm);
    },
    handleTagClose(index) {
      this.timeList.splice(index, 1);
      if (this.timeList.length == 0) {
        this.ruleForm.time = [];
        this.$refs.form.validateField("time");
      }
    },

    addZero(num) {
      return num < 10 ? "0" + num + ":00" : num == 24 ? "23:59" : num + ":00";
    },
    handleSelectConfirm(arr) {
      let isHave = this.timeList.some((el) => {
        return el.startTime == this.addZero(arr[0]) && el.endTime == this.addZero(arr[1]);
      });
      if (isHave) {
        this.$message.warning("该时段已存在，请重新选择");
        return;
      }
      this.timeList.push({
        startTime: this.addZero(arr[0]),
        endTime: this.addZero(arr[1]),
      });
      this.ruleForm.time = this.timeList;
    },
    // 时间段回调
    handleSelectTime(item) {
      if (this.beginTime) {
        if (this.beginTime == item) {
          this.$message.warning("开始时间和结束时间不能相同");
          return;
        }
        this.endTime = item;
        this.showDate = false;
        this.handleSelectConfirm(
          [this.beginTime, this.endTime].sort((a, b) => {
            return a - b;
          })
        );
        this.$nextTick(() => {
          this.beginTime = "";
          this.endTime = "";
        });
      } else {
        this.beginTime = item;
        this.endTime = "";
      }
      this.$refs.form.clearValidate("time");
    },
    //新建巡更点位传值
    passPoint(point) {
      this.point = point;
      this.patrolPlanCode = "";
      this.isEdit = false;
    },
    //编辑打开修改面板
    open(planInfo) {
      console.log("巡更详情", planInfo);
      this.isEdit = true;
      let patrolPointTable = [];
      if (planInfo) {
        this.patrolPlanCode = planInfo.patrolPlanCode;
        this.ruleForm.planName = planInfo.planName;
        this.ruleForm.deviation = planInfo.deviation;
        this.ruleForm.dateType = planInfo.dateType.toString();
        this.ruleForm.planDate = [planInfo.planStartTime, planInfo.planEndTime];
        this.timeList = planInfo.patrolPlanCycleList; //时间范围
        this.executeTeams = planInfo.accountNumberDetail.map((item) => {
          return {
            id: item.accountNo,
            name: item.nickName,
          };
        });
        this.ruleForm.time = this.timeList;
        planInfo.patrolPlanPointList.forEach((item) => {
          patrolPointTable.push({
            altitude: item.altitude || item.height,
            width: item.width,
            buildName: item.buildName,
            buildingId: item.buildingId,
            floorId: item.floorId,
            floorName: item.floorName,
            latitude: item.latitude,
            area: item.location,
            coord: [item.longitude, item.latitude],
            longitude: item.longitude,
            pointCode: item.pointCode, //已有点位
            name: item.pointName,
            type: item.punchType,
            sortNum: 0,
          }); //点位集合
        });
        this.patrolPointTable = [...patrolPointTable];
        if (this.panelType != 2) {
          // 编辑状态
          this.handleChangePoint();
          if (this.ruleForm.dateType == 1) {
            this.handleDateChange(1);
          }
        } else {
          //详情
          this.$refs.form.clearValidate();
        }
        console.log(this.ruleForm);
        console.log(this.patrolPointTable);
      }
    },
    // 收起面板
    showPlanListPanel() {
      this.showPanel = !this.showPanel;
    },
    // 取消面板
    handleClosePanel() {
      this.$map.MapInstance2D.clearLayer(this.temporaryId);
      this.$map.MapInstance2D.clearLayer(this.temporaryIdNum);
      this.$emit("handleCancelPanel");
      this.handleCloseDialog();
      this.openPanel = false;
      this.patrolPointTable = [];
      this.timeList = [];
      this.executeTeams = [];
      this.checkPeople = [];
      this.isEdit = false;
      this.$refs["form"].resetFields();
    },
    //保存面板内容
    handleSavePanel() {
      console.log(this.ruleForm);
      this.ruleForm.accountNumber = this.executeTeams;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.patrolPointTable.length === 0) {
            this.$message.warning("请选择巡更位置");
            return;
          }
          const param = {
            planName: this.ruleForm.planName,
            planStartTime: this.ruleForm.planDate[0], //开始时间
            planEndTime: this.ruleForm.planDate[1], //结束时间
            deviation: this.ruleForm.deviation, //范围偏差
            patrolPlanCycleList: this.timeList, //时间段
            dateType: this.ruleForm.dateType, //日期类型
            accountNumber: this.ruleForm.accountNumber.map((item) => {
              return item.id;
            }), //执行人
            patrolPlanPointList: this.patrolPointTable.map((item, index) => {
              return {
                altitude: item.height || item.altitude, //高度
                width: item.width, //宽度
                buildName: item.buildName, //建筑物名称
                buildingId: item.buildingId, //建筑物id
                floorId: item.floorId, //楼层id
                floorName: item.floorName, //楼层名称
                location: item.area, //位置
                pointCode: item.pointCode,
                latitude:
                  item.area == "室外" ? Number(item.coord[1]).toFixed(10) : item.coord[1], //纬度
                longitude:
                  item.area == "室外" ? Number(item.coord[0]).toFixed(10) : item.coord[0], //经度
                pointName: item.name,
                punchType: item.type,
                sortNum: index,
              };
            }),
          };
          let url = api.patrolplan.addPatrolPlan;
          if (this.isEdit) {
            url = api.patrolplan.updatePatrolPlan;
            param.patrolPlanCode = this.patrolPlanCode;
          }
          console.log(param);
          this.btnLoading = true;
          this.$fetch(url, param).then((res) => {
            this.btnLoading = false;
            if (!res.success) {
              this.$message.error(res.msgContent);
              return;
            }
            this.$message({
              type: "success",
              message: (this.isEdit ? "修改" : "创建") + "成功!",
            });
            this.$map.MapInstance2D.clearLayer(this.temporaryId);
            this.$map.MapInstance2D.clearLayer(this.temporaryIdNum);
            this.openPanel = false;
            this.isEdit = false;
            this.patrolPointTable = [];
            this.timeList = [];
            this.executeTeams = [];
            this.checkPeople = [];
            this.$refs["form"].resetFields();
            this.$emit("handleSaveEmit");
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.work-group {
  height: 700px;
  overflow: hidden;
}
.el-input-number__decrease,
.el-input-number__increase {
  // background: rgba(24, 31, 46, 0.65);
  // border-color: rgba(24, 31, 46, 0.65);
  color: black;
}
#patrol-route-panel-con {
  position: absolute;
  top: 0px;
  display: flex;
  right: 0;
  height: 100%;
  z-index: 2;

  .plan-list-toolbars {
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    /* display: flex; */
    position: absolute;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    top: 0;
  }
  .iclass {
    color: #fff;
    cursor: pointer;
    @include set_theme_color(background-color, main-theme-color);
    padding: 8px 10px 7px;
  }
  .el-tag {
    color: #e1e1e1;
    // width: 120px;
    height: 28px;
    border-radius: 1px;
    margin-right: 16px;
    margin-bottom: 8px;
    background: rgba(64, 122, 238, 0.65);
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #407aee;
    .el-tag__close {
      color: #fff;
    }
  }

  .dateTime {
    position: absolute;
    width: 152%;
    display: flex;
    left: -111px;
    height: 230px;
    background: rgba(175, 179, 180, 1);
    border-radius: 5px;
    z-index: 2;
    padding: 10px 16px;
    flex-wrap: wrap;
    .time {
      width: 42px;
      height: 30px;
      background: #fff;
      text-align: center;
      margin: 6px 0;
      width: calc(100% / 6);
      &:hover {
        cursor: pointer;
        background: #407aee;
        padding: 0 10px;
      }
    }
    .active {
      color: #fff;
      background: #407aee;
    }
  }
  .pickerTime {
    height: 0;
    border: none;
    .ioc-picker {
      display: none;
    }
  }
  .patrol-route-panel {
    position: absolute;
    width: 420px;
    right: -450px;
    height: 100%;
    padding: 12px;
    @include set_animation(all);
  }
  .plan-list-shows {
    right: 0;
    @include set_animation(all);
  }
  .el-table {
    // background-color: rgba(0, 0, 0, 0.01);
  }
  .el-tabs__nav-scroll {
    margin-left: 22px;
  }
  .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: hidden;
    overflow-y: auto;
  }
  .line-distance {
    padding-right: 5px;
  }
  .pointTemplate {
    margin: 3px 0;
    width: 350px;
  }
  .pointTemplate_content {
    overflow: auto;
    height: 120px;
  }
  .header {
    border-left: 4px solid #407aee;
    position: relative;
    // width: 350px;
    line-height: 16px;
    text-align: left;
    padding-left: 10px;
    font-size: 16px;
    margin: 6px 10px 12px;
    // @include set_theme_color(background-color, table-header-bg-color);
  }
  .ele-planInfo {
    @include set_theme_color(background-color, map-panel-content);
    // background: rgba(26, 31, 43, 1);
    padding: 10px;
    margin-bottom: 15px;
    // height: calc(25% - 32px);
  }
  .operator-btn {
    display: inline-block;
    font-size: 12px;
    padding: 5px;
    cursor: pointer;
    width: 20px;
    line-height: 20px;
  }
  .templateList {
    line-height: 40px;
    border-bottom: 1px solid #212630;
    // background: #0d121c;
    .el-radio {
      color: #fff;
      width: 65%;
      margin-left: 18px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .iconsetting {
    width: 10%;
    display: inline-block;
    text-align: center;
  }
  .person-btn {
    color: #9aa6c1;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
    background-color: #0d121c;
  }
  .person-btn i {
    margin: 0 5px;
  }
  .change-select {
    // @include set_theme_color(background-color, dialog-content-bg-color);
    // background: rgba(26, 31, 43, 1);
    height: calc(42% - 15px);
    margin-bottom: 15px;
  }
  .person-select {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding: 12px 12px;
  }
  .person-select-title {
    border-left: 4px solid #407aee;
    position: relative;
    line-height: 16px;
    text-align: left;
    padding-left: 10px;
    font-size: 16px;
    margin: 0px 10px px 12px;
  }
  .workGroup-list {
    margin-bottom: 12px;
    width: 350px;
    overflow: auto;
    height: 150px;
    display: flex;
    flex-direction: column;
  }
  .ruleAdd-dialog {
    position: relative;
    overflow: hidden;
    height: calc(100% - 70px);
  }
  .el-date-editor .el-range-separator {
    width: 9% !important;
    margin-right: 5%;
  }
  .el-table__body-wrapper {
    background: rgba(24, 31, 46, 0) !important;
    .el-table__empty-text {
      color: #fff;
    }
  }
  .el-table tbody tr {
    // background: rgba(0, 0, 0, 0) !important;
    &:hover {
      // background: #242b3d !important;
    }
    &:nth-child(even) {
      // background: #242b3d !important;
    }
  }

  .footer {
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    position: absolute;
    width: 100%;
  }
}
</style>
